<template>
  <a-modal v-model="visible" :afterClose="resetModal" :title="title">
    <a-form-model
      ref="addSupportform"
      :model="confirmAddSupport"
      :rules="rules"
      class="pt-4"
    >
      <a-form-model-item prop="password">
        <a-input-password
          class="mb-2 mt-2"
          size="large"
          v-model="confirmAddSupport.password"
          placeholder="Temporary Passoword"
        >
          <a-icon slot="prefix" type="lock" class="input-icon" />
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item prop="companyName">
        <a-input
          size="large"
          v-model="confirmAddSupport.companyName"
          placeholder="Confirm company name"
        >
          <a-icon slot="prefix" type="bank" class="input-ico n" />
        </a-input> 
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button type="primary" @click="ok" :loading="loading" :disabled="!formIsValid">Add</a-button>
      <a-button @click="cancel">Cancel</a-button>
    </template>
  </a-modal>
</template>
<script>
export default {
  props: {
    value: Boolean,
    companyName: String,
    loading:Boolean,
  },
  data() {
    return {
      confirmAddSupport: {
        password: "",
        companyName: "",
      },
      rules: {
        password: [
          {
            required: true,
            message: "Please input your Temporary Password",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: "Please input your Company Name!",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    formIsValid: function () {
          return this.confirmAddSupport.password !== "" &&  this.confirmAddSupport.companyName !== "" ;
      },
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
      title: {
      get() {
        return `Add Support user to '${this.companyName}'`;
      },
    },
  },

  methods: {
    cancel() {
      this.visible = false;
    },
    ok() {
      this.$refs.addSupportform.validate(async (valid) => {
        if (valid) {
          this.$emit("addUser", this.confirmAddSupport);
        }
      });
    },
    resetModal() {
      this.confirmAddSupport.password = "";
      this.confirmAddSupport.companyName = "";
    },
  },
};
</script>
